__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "yepic-studio";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amplitude/analytics-browser", "1.13.6", () => (__webpack_require__.e(2871).then(() => (() => (__webpack_require__(2871))))));
			register("@headlessui/react", "1.7.19", () => (__webpack_require__.e(6079).then(() => (() => (__webpack_require__(6079))))));
			register("@sentry/react", "7.119.0", () => (__webpack_require__.e(6179).then(() => (() => (__webpack_require__(6179))))));
			register("@sentry/tracing", "7.114.0", () => (__webpack_require__.e(2801).then(() => (() => (__webpack_require__(2801))))));
			register("axios", "1.7.7", () => (__webpack_require__.e(4344).then(() => (() => (__webpack_require__(4344))))));
			register("dayjs", "1.11.13", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(446))))));
			register("deep-diff", "1.0.2", () => (__webpack_require__.e(7682).then(() => (() => (__webpack_require__(7682))))));
			register("fabric-guideline-plugin", "0.0.11", () => (__webpack_require__.e(8130).then(() => (() => (__webpack_require__(8130))))));
			register("fabric", "5.4.0", () => (__webpack_require__.e(6661).then(() => (() => (__webpack_require__(6661))))));
			register("formik", "2.4.6", () => (__webpack_require__.e(648).then(() => (() => (__webpack_require__(648))))));
			register("framer-motion", "11.8.0", () => (__webpack_require__.e(7685).then(() => (() => (__webpack_require__(7685))))));
			register("iconsax-reactjs", "0.0.8", () => (__webpack_require__.e(1810).then(() => (() => (__webpack_require__(1810))))));
			register("idb-keyval", "6.2.1", () => (__webpack_require__.e(7540).then(() => (() => (__webpack_require__(7540))))));
			register("lottie-react", "2.4.0", () => (__webpack_require__.e(3750).then(() => (() => (__webpack_require__(3750))))));
			register("mic-recorder-to-mp3", "2.2.2", () => (__webpack_require__.e(246).then(() => (() => (__webpack_require__(246))))));
			register("posthog-js", "1.165.0", () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(961))))));
			register("react-beautiful-dnd", "13.1.1", () => (__webpack_require__.e(2545).then(() => (() => (__webpack_require__(2545))))));
			register("react-colorful", "5.6.1", () => (__webpack_require__.e(4497).then(() => (() => (__webpack_require__(4497))))));
			register("react-confetti", "6.1.0", () => (__webpack_require__.e(1151).then(() => (() => (__webpack_require__(1151))))));
			register("react-custom-scrollbars-2", "4.5.0", () => (__webpack_require__.e(3360).then(() => (() => (__webpack_require__(3360))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(7950))), 1);
			register("react-error-boundary", "4.0.13", () => (__webpack_require__.e(3632).then(() => (() => (__webpack_require__(3632))))));
			register("react-h5-audio-player", "3.9.3", () => (__webpack_require__.e(488).then(() => (() => (__webpack_require__(488))))));
			register("react-helmet", "6.1.0", () => (__webpack_require__.e(1591).then(() => (() => (__webpack_require__(1591))))));
			register("react-intersection-observer", "9.13.1", () => (__webpack_require__.e(5843).then(() => (() => (__webpack_require__(5843))))));
			register("react-loader-spinner", "5.4.5", () => (__webpack_require__.e(6999).then(() => (() => (__webpack_require__(6999))))));
			register("react-phone-number-input", "0", () => (__webpack_require__.e(1557).then(() => (() => (__webpack_require__(1557))))));
			register("react-range-slider-input", "3.0.7", () => (__webpack_require__.e(1123).then(() => (() => (__webpack_require__(1123))))));
			register("react-router", "6.26.2", () => (__webpack_require__.e(3216).then(() => (() => (__webpack_require__(3216))))));
			register("react-share", "4.4.1", () => (__webpack_require__.e(1587).then(() => (() => (__webpack_require__(1587))))));
			register("react-time-picker", "5.2.0", () => (__webpack_require__.e(8905).then(() => (() => (__webpack_require__(8905))))));
			register("react-tooltip", "5.28.1", () => (__webpack_require__.e(9532).then(() => (() => (__webpack_require__(9532))))));
			register("react-use-intercom", "5.4.3", () => (__webpack_require__.e(1839).then(() => (() => (__webpack_require__(1839))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(5043))), 1);
			register("store", "2.0.12", () => (__webpack_require__.e(3366).then(() => (() => (__webpack_require__(3366))))));
			register("tailwind-merge", "2.5.2", () => (__webpack_require__.e(9359).then(() => (() => (__webpack_require__(9359))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(8355).then(() => (() => (__webpack_require__(8355))))));
			register("yup", "0.32.11", () => (__webpack_require__.e(3467).then(() => (() => (__webpack_require__(3467))))));
			register("zustand-middleware-computed-state", "0.1.3", () => (__webpack_require__.e(5054).then(() => (() => (__webpack_require__(5054))))));
			register("zustand", "4.5.5", () => (__webpack_require__.e(4548).then(() => (() => (__webpack_require__(4548))))));
			initExternal(5108);
			initExternal(7034);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};